'use client';

import { Image } from '@/components/ui/image/image';
import { getVideoEmbedUrl } from '@/lib/utils/video-url';
import styles from './embedded-blocks.module.scss';

type EmbeddedMediaProps = {
  mediaType: 'image' | 'lottie' | 'video';
  imageSrc?: string;
  lottieUrl?: string;
  videoUrl?: string;
  altText?: string;
  caption?: string;
};

export const EmbeddedMedia = ({
  mediaType,
  imageSrc,
  lottieUrl,
  videoUrl,
  altText,
  caption,
}: EmbeddedMediaProps) => {
  if (mediaType === 'video') {
    const embedUrl = videoUrl ? getVideoEmbedUrl(videoUrl) : null;
    if (!embedUrl) return null;
    return (
      <div className={styles.video}>
        <div className={styles.video__wrapper}>
          <iframe
            src={embedUrl}
            title={altText || 'Video'}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; compute-pressure"
            allowFullScreen
            className={styles.video__iframe}
          />
        </div>
        {caption && <p className={styles.video__caption}>{caption}</p>}
      </div>
    );
  }

  return (
    <figure className={styles.media}>
      {mediaType === 'image' && imageSrc && (
        <Image
          src={imageSrc}
          alt={altText || ''}
          width={792}
          height={500}
          className={styles.media__image}
        />
      )}
      {mediaType === 'lottie' && lottieUrl && (
        <iframe src={lottieUrl} title={altText || 'Animation'} className={styles.media__lottie} />
      )}
      {caption && <figcaption className={styles.media__caption}>{caption}</figcaption>}
    </figure>
  );
};
